import { downloadByUrl } from '@/utils/downloadFile';
import { http } from '@/utils/http/axios';

import {
  DownloadShopTopExportParams,
  GetShopBrandApiParams,
  GetShopBrandSimpleIndexApi,
  GetShopBrandSimpleIndexApiParams,
  GetShopCategorys,
  GetShopHotBrand,
  GetShopIndexApi,
  GetShopIndexParams,
  GetShopJsIndex,
  GetShopJsIndexSKUApi,
  GetShopMessageApi,
  GetShopOftenShopsApi,
  GetShopSimpleIndexApi,
  GetShopSimpleIndexEchartsLineApi,
  GetShopTopMalls,
} from './type';

//获取table
export function getShopJsIndex(params) {
  return http.request<GetShopJsIndex>({
    url: '/shop/jsIndex',
    method: 'get',
    params,
  });
}
// /shop/categorys
export function getShopCategorysApi() {
  return http.request<GetShopCategorys[]>({ url: '/shop/categorys' });
}
// shop/topExport
export function downloadShopTopExport(params: DownloadShopTopExportParams) {
  return downloadByUrl('/shop/topExport', {
    params,
  });
}
// shop/jsIndexSku
export function getShopJsIndexSKUApi(params: { day?: any; skuId: string }) {
  return http.request<GetShopJsIndexSKUApi>({
    url: '/shop/jsIndexSku',
    method: 'post',
    data: params,
  });
}
// /shop/topMalls
export function getShopTopMalls(goodsId: string) {
  return http.request<GetShopTopMalls[]>({
    url: '/shop/topMalls',
    method: 'get',
    params: { goodsId },
  });
}

// shop/simpleIndexEchartsLine
export function getShopSimpleIndexEchartsLineApi() {
  return http.request<GetShopSimpleIndexEchartsLineApi>({
    url: '/shop/simpleIndexEchartsLine',
    method: 'get',
  });
}

// /shop/getOftenShops
export function getShopOftenShopsApi() {
  return http.request<Array<GetShopOftenShopsApi>>({
    url: '/shop/getOftenShops',
    method: 'get',
  });
}
// /shop/hotBrand
export function getShopHotBrand(params: { mallId: string }) {
  return http.request<Array<GetShopHotBrand>>({
    url: '/shop/hotBrand',
    method: 'get',
    params,
  });
}
// /shop/brandSimpleIndex
export function getShopBrandSimpleIndex(params: GetShopBrandSimpleIndexApiParams) {
  return http.request<Array<GetShopBrandSimpleIndexApi>>({
    url: '/shop/brandSimpleIndex',
    method: 'get',
    params,
  });
}
// /shop/simpleIndex
export function getShopSimpleIndexApi() {
  return http.request<Array<GetShopSimpleIndexApi>>({
    url: '/shop/simpleIndex',
    method: 'get',
  });
}
// /shop/message
export function getShopMessageApi() {
  return http.request<Array<GetShopMessageApi>>({
    url: '/shop/message',
    method: 'get',
  });
}

// /shop/read
export function readShopMessage() {
  return http.request({
    url: '/shop/read',
    method: 'get',
  });
}
// /shop/index
/**
 * 获取商城列表
 * @param { {keyword?: string;region?: string;often?: boolean;master?: boolean;}} params
 * @url /shop/index
 * @returns
 */
export function getShopIndexApi(params?: GetShopIndexParams) {
  return http.request<Array<GetShopIndexApi>>({
    url: '/shop/index',
    method: 'get',
    params,
  });
}
// /shop/brand
// 获取商城列表
export function getShopBrandApi(params?: GetShopBrandApiParams) {
  return http.request<Array<GetShopHotBrand>>({
    url: '/shop/brand',
    method: 'get',
    params,
  });
}
//jessica商城 hotBrand
export function getShopJsHotBrand(params?: GetShopBrandApiParams) {
  return http.request<Array<GetShopHotBrand>>({
    url: '/shop/brandRp',
    method: 'get',
    params,
  });
}
// /shop/malls
export function getShopMallsApi() {
  return http.request<Array<GetShopIndexApi>>({
    url: '/shop/malls',
    method: 'get',
  });
}

export function getExportMallsApi(data) {
  return http.request({
    url: 'shop/exportMalls',
    method: 'post',
    data,
  });
}
